module.exports = __webpack_public_path__ + "static/granulat_sloik@0,75x-9148b8ac8900a588d3587e3bc5bde2d3.png";